export function propertyName(prefix: string = "", suffix: string = ""): PropertyDecorator {
  return (target: Object, propertyKey: string | symbol) => {
    target[propertyKey] = prefix + propertyKey.toString() + suffix;
  };
}
